module.exports = __webpack_public_path__ + "img/百年征程.e61d3cba.png";